import PropTypes from 'prop-types'
import { sliceStatusPropTypes } from '../slice.types'

export const initialFeatureFlagsState = {
  status: 'idle',
  errors: [],
  flags: {}
}

export const FEATURE_FLAGS_ACTIONS = {
  SET_FEATURE_FLAGS_STATUS: 'SET_FEATURE_FLAGS_STATUS',
  SET_FEATURE_FLAGS_ERRORS: 'SET_FEATURE_FLAGS_ERRORS',
  SET_FEATURE_FLAG: 'SET_FEATURE_FLAG',
  CLEAR_FEATURE_FLAGS_ERRORS: 'CLEAR_FEATURE_FLAGS_ERRORS'
}

export const featureFlagEntryPropType = PropTypes.shape({
  enabled: PropTypes.bool,
  checkedAt: PropTypes.number
})

export const featureFlagsSlicePropType = PropTypes.shape({
  status: sliceStatusPropTypes,
  errors: PropTypes.arrayOf(PropTypes.shape({ message: PropTypes.string })),
  flags: PropTypes.objectOf(featureFlagEntryPropType)
})
